import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessageWrappedInSpan } from '../../misc';

import CartItem from './CartItem';
import { PhotoBookMsg } from '../../messages';

function CartLineItemPhotoBook(props) {
  const { lineItem, ...other } = props;

  return (
    <CartItem
      icon={
        <div className="cart-item-icon-container">
          <img src="/images/packshot-4721.png" />
        </div>
      }
      isDownloadOnly={false}
      lineItem={lineItem}
      subtitle={
        <FormattedMessageWrappedInSpan
          id="cartLineItemPhotoBook.additionalShipping"
          defaultMessage="Shipping costs not included"
        />
      }
      subtitleHasHelpIcon={true}
      title={<PhotoBookMsg />}
      {...other}
    />
  );
}

CartLineItemPhotoBook.propTypes = {
  lineItem: PropTypes.object,
};

export default CartLineItemPhotoBook;
